FamilycardsImageLibrary.controller('imageEditorDesignController', [ '$scope', '$http', '$timeout', function( $scope, $http, $timeout ) {

    $scope.currentSide = 'frontPage';
    $scope.currentSideUrl = window.editor_design_urls.frontPage;

    $scope.setCurrentSide = function( side ) {
        $scope.currentSide = side;
        $scope.currentSideUrl = window.editor_design_urls[side];
    };

    console.log(window.editor_design_urls);

    var protocol = window.location.protocol;
    var hostname = window.location.hostname;
    var editor_design_id = window.editor_design_id;

    if( window.is_generated )
        return;

    if( window.editor_template ) {
        var url = protocol + '//' + hostname + '/api/opmaak_template/' + editor_design_id + '/generated'
    } else {
        var url = protocol + '//' + hostname + '/api/opmaak/' + editor_design_id + '/generated'
    }

    var checkForCompletedGeneration = function() {

        $http({
			method: 'GET',
			url: url,
		}).
		success( function( response, status, headers, config ) {
            
            if( !response.is_generated ) {
                $timeout(checkForCompletedGeneration, 5000);
            } else {
                location.reload(); 
            }

		}).
		error(function(data, status, headers, config) {
            $timeout(checkForCompletedGeneration, 5000);
        });

    }

    checkForCompletedGeneration();
        
}]);